import { render, staticRenderFns } from "./RuleBulkModal.ts.vue?vue&type=template&id=7c63659c"
import script from "./RuleBulkModal.ts.vue?vue&type=script&lang=ts"
export * from "./RuleBulkModal.ts.vue?vue&type=script&lang=ts"
import style0 from "./RuleBulkModal.ts.vue?vue&type=style&index=0&id=7c63659c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports